import { logger } from '../utils/logger/logger';
import { Validator, ExtendedFieldId } from '../types/types';

let customValidators = {};
let customValidatorFields: ExtendedFieldId[] = [];

export const setCustomValidator = (validatorField: ExtendedFieldId, newValidator: Validator) => {
    logger.log(`customValidator registering \n${newValidator}\n for custom field '${validatorField}'`);
    customValidators[validatorField] = newValidator;
    customValidatorFields.push(validatorField);
};

export const getCustomValidator = (validatorField: ExtendedFieldId): Validator => {
    if (customValidators[validatorField]) {
        logger.log(`getCustomValidator returning '${validatorField}'`);
        return customValidators[validatorField];
    }
    logger.error(`Custom validator for field '${validatorField}' does not exist.
        Has a custom validator been registered using the setCustomValidator method?`);
    return null;
};

export const getCustomValidatorFields = (): ExtendedFieldId[] => {
    return customValidatorFields;
};

export const resetCustomValidators = () => {
    customValidators = {};
    customValidatorFields = [];
    logger.info('Custom validators have been reset');
};
